import type {Reporter, ReportOpts} from '../Reporter';
import {Severity} from '../types';

const consoleSeverity: Record<Severity, keyof Pick<Console, 'error' | 'warn' | 'log'>> = {
    [Severity.Error]: 'error',
    [Severity.Info]: 'log',
    [Severity.Warning]: 'warn',
};

export class ConsoleReporter implements Reporter {
    public report({severity, message, error, extra}: ReportOpts) {
        const key = consoleSeverity[severity];
        console[key](message, {severity, error, extra});
    }
}
